// extracted by mini-css-extract-plugin
export default {"box":"bulkSpareLotListItemDetailPage_box__Lgbvy"};